import ScreensaverContentAddContainer from 'components/feature/screensaver/contents/add/ScreensaverContentAddContainer';
import React from 'react';

const ScreensaverContentAddPage = () => {
  return <ScreensaverContentAddContainer />;
};
export default ScreensaverContentAddPage;
